import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CategoryIcon from "@mui/icons-material/Category";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { StepContainer, FeatureCard } from "../styles";
import { stepContent } from "../content";
import { ModernButton } from "../../styled/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const MenuProductsStep = ({ onNavigate }) => {
  const theme = useTheme();
  const content = stepContent.menuProducts;

  const featureIcons = [MenuBookIcon, ReceiptLongIcon, CategoryIcon, PriceCheckIcon];

  return (
    <StepContainer>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {content.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {content.subtitle}
        </Typography>
      </Box>

      {/* Features Grid */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {content.features.map((feature, index) => {
          const Icon = featureIcons[index];
          return (
            <Grid item xs={12} sm={6} key={index}>
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 }}
              >
                <FeatureCard elevation={2} color={theme.palette.primary.main}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      bgcolor: (theme) =>
                        theme.palette.mode === "light"
                          ? theme.palette.primary.lighter || theme.palette.primary.light
                          : theme.palette.primary.dark,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <Icon sx={{ color: "primary.main", fontSize: 28 }} />
                  </Box>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </FeatureCard>
              </motion.div>
            </Grid>
          );
        })}
      </Grid>

      {/* CTA */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: "auto" }}>
        <ModernButton
          onClick={() => onNavigate && onNavigate(content.ctaRoute)}
          endIcon={<ArrowForwardIcon />}
          size="large"
        >
          {content.ctaLabel}
        </ModernButton>
      </Box>
    </StepContainer>
  );
};

export default MenuProductsStep;
